export interface PwRequirement { label: string; test: (pw: string) => boolean; }

// Muss zur manuell angelegten Keycloak-Passwort-Policy passen:
// min. 8 Zeichen, Gross-, Kleinbuchstabe und Sonderzeichen (keine Ziffer erforderlich).
// Unicode-aware, damit Umlaute korrekt als Buchstaben und nicht als Sonderzeichen zaehlen.
export const PASSWORD_REQUIREMENTS: PwRequirement[] = [
  { label: "Mindestens 8 Zeichen", test: (pw) => pw.length >= 8 },
  { label: "Grossbuchstabe",       test: (pw) => /\p{Lu}/u.test(pw) },
  { label: "Kleinbuchstabe",       test: (pw) => /\p{Ll}/u.test(pw) },
  { label: "Sonderzeichen",        test: (pw) => /[^\p{L}\p{N}]/u.test(pw) },
];

// gibt null zurueck, wenn ok, sonst eine Fehlermeldung mit den offenen Punkten
export function validatePassword(pw: string): string | null {
  const missing = PASSWORD_REQUIREMENTS.filter((r) => !r.test(pw));
  if (missing.length === 0) return null;
  return "Das Passwort erfüllt nicht alle Anforderungen: "
    + missing.map((r) => r.label).join(", ") + ".";
}

// Live-Checkliste: haengt an ein Passwort-Input eine Liste, die beim Tippen aktualisiert
export function mountPasswordChecklist(input: HTMLInputElement, container: HTMLElement): void {
  const render = () => {
    const pw = input.value;
    container.innerHTML = PASSWORD_REQUIREMENTS.map((r) => {
      const ok = r.test(pw);
      return `<li class="pw-req ${ok ? "met" : ""}">${ok ? "✓" : "○"} ${r.label}</li>`;
    }).join("");
  };
  input.addEventListener("input", render);
  render();
}
